import React from 'react';
import { Label } from 'vetrf-ui';
import styles from './CountryType.module.scss';

type CountryTypeProps = {
  isResident?: boolean;
};

export const CountryType = ({ isResident }: CountryTypeProps) =>
  isResident !== undefined && isResident !== null ? (
    <Label
      className={styles.countryType}
      arrowedRight="arrowed"
      color={isResident ? 'success' : 'info'}
      text={isResident ? 'Отечественный' : 'Зарубежный'}
      size="sm"
    />
  ) : null;
